import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-recursive-report',
  templateUrl: './recursive-report.component.html',
  styleUrls: ['./recursive-report.component.scss'],
})
export class RecursiveReportComponent {
  @Input() menusArray: any;
  @Input() menus: any;
  @Input() editor: any;
  @Input() level: any;
  @Input() edit: boolean = true;

  getTopLevelMenus(): any[] {
    return this.menus.filter((menu: any) => menu.parent === null);
  }

  // Method to get nested menus based on parent index
  getNestedMenus(parentIndex: number): any[] {
    if (this.menusArray) {
      return this.menusArray.filter((menu: any) => menu.parent === parentIndex);
    }

    return [];
  }

  trackByMenuId(index: number, menu: any): number {
    return menu.index; // Or use a unique field that identifies each menu
  }

  getParentName(parentIndex: number | null): string {
    if (parentIndex === null) {
      return 'No Parent';
    }
    const parentMenu = this.menusArray.find(
      (menu: any) => menu.index === parentIndex
    );
    return parentMenu ? parentMenu.title : 'No Parent';
  }
}
